import { getLocale } from 'src/stores/locale'

export const formatNum = (
  n?: number,
  options?: { uppercase?: boolean; fixedDigits?: number; addPrefix?: boolean },
) => {
  const fixedDigits = options?.fixedDigits ?? 2

  if (n == null) return

  // Use absolute value to avoid double negative sign bug
  const absN = Math.abs(n)
  let formattedValue: string

  if (absN < 1e3) {
    formattedValue = absN.toString()
  } else if (absN < 1e6) {
    formattedValue =
      (absN / 1e3).toFixed(fixedDigits) + (options?.uppercase ? 'K' : 'k')
  } else {
    formattedValue =
      (absN / 1e6).toFixed(fixedDigits) + (options?.uppercase ? 'M' : 'm')
  }

  if (options?.addPrefix) {
    // Use Intl.NumberFormat to determine sign
    const signFormatter = new Intl.NumberFormat('en-US', {
      signDisplay: 'always',
    })
    const sign = n === 0 ? '' : signFormatter.format(n).charAt(0)
    return sign + formattedValue
  }

  // For non-prefix case, negative numbers still need the sign
  return n < 0 ? '-' + formattedValue : formattedValue
}

export const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export function formatPercentage(value: number) {
  const formatter = new Intl.NumberFormat(getLocale(), {
    style: 'percent',
    maximumFractionDigits: 0,
  })

  return formatter.format(value)
}
